module.exports = __webpack_public_path__ + "static/img/lolabunny.6854f6f7.png";